import Cookie from 'js-cookie';
import Vue from "vue";

export default {
    namespaced: true,
    state: {
        profile: null,
        loggedIn: !!Cookie.get('access_token'),
        hasRefreshToken: !!Cookie.get('refresh_token'),
        isRefreshed: false,
    },

    getters: {
        profile: state => state.profile,
        loggedIn: state => state.loggedIn,
        hasRefreshToken: state => state.hasRefreshToken,
        isRefreshed: state => state.isRefreshed,
    },

    mutations: {
        SET_PROFILE: (state, payload = null) => {
            state.profile = payload;
            state.loggedIn = !!payload;
        },
        SET_PROFILE_PERMISSIONS: (state, payload = null) => {
            state.permissions = payload;
        },
        SET_REFRESHED: (state, payload = false) => {
            state.isRefreshed = payload;
        },
    },

    actions: {
        // todo Дима маленькими
        LOGIN: async function ({commit}, payload) {
            let {data} = await this.$api.auth.login(payload);
            this.resetJWT(data.token);

            commit('SET_PROFILE', data);
        },

        RESET_PROFILE: async function ({commit}) {
            commit('SET_PROFILE');
            commit('SET_PROFILE_PERMISSIONS');
            this.removeJWT()
        },

        // eslint-disable-next-line no-unused-vars
        REFRESH_TOKEN: async function ({dispatch}, payload) {
            let {data} = await this.$api.auth.refreshToken(payload);

            await this.resetJWT(data);
            await dispatch('GET_PROFILE');
        },

        LOGOUT: async function () {
            console.log('LOGOUT')

            this.removeJWT()
            location.reload()
            // commit('SET_PROFILE')
            // commit('session/CLEAR_SESSION', null, { root: true })
        },

        GET_PROFILE: async function ({commit}) {

            let loading = Vue.prototype.$loading({
                lock: true,
                text: 'Обновление данных...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })

            this.$api.auth.profile()
                .then((response) => {
                    commit('SET_PROFILE', response.data);
                })
                .catch(() => {
                    // dispatch('auth/LOGOUT')
                    // document.location.href = "/signin"
                })
                .finally(() => {
                    loading.close();
                })

        },
    },
};
